<template>
  <div class="collection-gifting-page">
    <div v-if="!isMobile() && (this.currentStep > 0 || selectedCollection)" class="gifting-header">
      <div v-for="(step,i) in steps" :key="step" class="header-step" :class="currentStep == i ? 'current' : ''">
        <p class="title">{{ step }}</p>
        <p class="circle"></p>
      </div>
      <div class="header-line"></div>
    </div>
    <div v-if="isMobile() && (this.currentStep > 0 || selectedCollection)" class="gifting-header">
      <div class="header-step current">
        <p class="title">{{ actualStep }}</p>
        <p class="circle"></p>
      </div>
      <div class="header-line"></div>
    </div>
    <div class="gifting-container">
      <BudgetSelection @selecttop="selectTop" v-if="currentStep == 0 && !selectedCollection"/>
      <CollectionDescription @changepage="changePage"  v-if="currentStep == 0 && selectedCollection"/>
      <EmailSelection @changepage="changePage" v-if="currentStep == 1"/>
      <EmailConfiguration @changepage="changePage" v-if="currentStep == 2"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BudgetSelection from './components/BudgetSelection.vue'
import EmailSelection from './components/EmailSelection.vue'
import EmailConfiguration from './components/EmailConfiguration.vue'
import CollectionDescription from './components/CollectionDescription.vue';
export default {
  components:{
    BudgetSelection,
    EmailSelection,
    EmailConfiguration,
    CollectionDescription
  },
  directives: {
  },
  data(){
    return{
      currentStep: 0,
      steps: ["1. SELECT COLLECTION","2. ADD RECIPIENTS","3. CUSTOMIZE YOUR EMAIL","4. THEY PICK THEIR GIFT"]
    }
  },
  computed:{
    ...mapGetters([
      'selectedCollection'
    ]),
    actualStep(){
      return this.steps[this.currentStep];
    }
  },
  methods:{
    selectTop(event){
      this.$store.commit('setSelectedCollection', event );
      this.changePage(true);
    },
    async changePage(event){
      if(event){
        this.currentStep++;
      }
      else {
        if(this.currentStep == 1 && this.selectedCollection.tags.every(y => y != "International" && y != "Featured")){
          this.$store.commit('setSelectedCollection', null );
        }
        this.currentStep--;
      }
      if(this.currentStep >= 1){
        let footer = document.querySelector("#shopify-section-footer");
        footer.style.display = "none";
      }
      else {
        let footer = document.querySelector("#shopify-section-footer");
        footer.style.display = "block";
      }
      history.pushState({step: this.currentStep},"");
      await this.$nextTick(() => {
        window.scrollTo(0,0);
      });
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  mounted() {
  },
  destroy() {
  }
}
</script>
<style>
.collection-gifting-page p
,.collection-gifting-page span
,.collection-gifting-page li{
  color: #0f0c38;
}

.filter-space{
  width: 15%;
}

</style>
<style scoped>
  .wiggle{
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-bottom: -1px;
	}
	.wiggle img{
    width: 120%;
    position: relative;
    left: -10%;
	}

  .wiggle.purple-white{
    background: linear-gradient(0deg, #3F3D60 40%, white 60%);
  }

  .gifting-header{
    display: flex;
    align-items: center;
    padding: 1% 1% 0;
        margin-top: 6%;
    position: relative;
    justify-content: center;
    margin-bottom: -1%;
  }

  .gifting-header p{
    color: #0f0c38;
    margin: unset;
    font-weight: bold;
  }

  .header-step{
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-step .title{
    color: #908FA3;
    font-family: karla;
    font-size: 0.85vw;
    margin: unset;
  }

  .header-step.current .title{
    color: #0f0c38;
    font-weight: bold;
  }

  .header-step .circle{
    width: 1vw;
    height: 1vw;
    border: 1px solid #0f0c38;
    background-color: #fdfdfd;
    border-radius: 20px;
    margin: unset;
    z-index: 1;
  }

  .header-step.current .circle{
    background-color: #CCDAFF;
    width: 2vw;
    height: 2vw;
  }

  .header-line{
    width: 100%;
    position: absolute;
    left: 0%;
    border-top: 1px solid black;
    bottom: 23.5%;
  }

  .gifting-container{
    position: relative;
  }

  .back{
    padding: 0% 5%;
    margin: 0;
    cursor: pointer;
  }

  .overhead{
    width: 100%;
    position: relative;
    display: flex;
  }

  .overhead .copy-container{
    position: absolute;
    width: 55%;
    top: 0%;
    left: 0%;
    bottom: 0%;
    display: flex;
    flex-direction: column;
    padding: 0% 0% 0% 5%;
    align-items: center;
    justify-content: center;
  }

  .overhead .copy-container .main-title{
    font-family: "moret";
    font-size: 4vw;
    font-weight: bold;
    line-height: 1;
    color: #0f0c38;
    padding-bottom: 3%;
    margin: unset;
    text-align: center;
  }

  .overhead .checks-container{
    width: 60%;
  }

  .overhead .check{
    font-size: 1.15vw;
    line-height: 1.2;
    display: flex;
    align-items: flex-start;
    color: #0f0c38;
    gap: 10px;
    margin-bottom: 2%;
    width: 100%;
    text-align: center;
  }

  .overhead .check img{
    width: 15px;
  }

  .overhead .check a img{
    width: 20px;
  }

  .overhead .check a{
    font-size: 1.15vw;
    line-height: 1.2;
    display: flex;
    align-items: center;
    color: #0f0c38;
    gap: 10px;
    margin-top: 2%;
    font-weight: bold;
    cursor: pointer;
  }


  .overhead .main-image{
    width: 100%;
    object-fit: cover;
  }

  .how-works{
    font-size: 1.15vw;
    line-height: 1.2;
    display: flex;
    align-items: center;
    color: #0f0c38;
    gap: 10px;
    position: absolute;
    bottom: 5%;
    right: 1%;
    font-weight: bold;
    cursor: pointer;
  }

  .how-works img{
    width: 20px;
  }
  

  @media only screen and (max-device-width: 767px){

    .overhead .copy-container{
      width: 100%;
      padding: 10% 10% 0%;
      justify-content: flex-start;
      text-align: center;
    }

    .overhead .main-image{
      aspect-ratio: unset;
    }

    .overhead .copy-container .main-title{
      font-size: 12vw;
      text-align: center;
      padding-bottom: 5%;
    }

    .overhead .checks-container{
      width: 100%;
    }

    .overhead .check{
      font-size: 3.5vw;
      margin-bottom: 4%;
      width: 100%;
      max-width: unset;
      padding: 0% 10%;
      justify-content: center;
    }

    .overhead .check img{
      width: unset;
    }

    .gifting-header{
      justify-content: center;
      padding: 5% 0% 0;
      margin-bottom: -2.5%;
      margin-top: unset;
    }

    .header-step.current .circle{
      width: 5vw;
      height: 5vw;
    }

    .header-step{
      width: 50%;
    }

    .header-step .title{
      font-size: 3.5vw;
    }

    .header-step .circle{
      width: 4vw;
      height: 4vw;
    }

    .header-line{
      bottom: 16.5%;
    }

    .back{
      position: absolute;
      left: 0%;
      top: 20%;
    }

    .overhead{
      min-height: 500px;
    }

    .overhead .check a{
      font-size: 3.5vw;
      justify-content: center;
    }

    .overhead .check a img{
      width: 25px;
    }
  }
 
</style>